import React, { useCallback } from 'react';

import { link } from '@aline/routes';
import { useAccessGuard } from 'src/components/auth';
import { PrimaryPlusIconButton } from 'src/components/generic';
import { Apollo } from 'src/gql/generated';
import { openLink } from 'src/helpers/url';
import { useCreateWorkflow } from 'src/workflow';

export function NewTemplateButton(): JSX.Element {
  const { createWorkflow, loading } = useCreateWorkflow();

  const handleCreate = useCallback(async () => {
    const { data } = await createWorkflow({
      variables: {
        input: { documentIds: [], props: { isTemplate: true } },
      },
      variant: Apollo.WorkflowVariant.Template,
    });
    if (!data) return;

    openLink(
      link.TemplateSelectedTemplateIndex({ workflowId: data.initializeWorkflow.workflow.id }),
      { title: data.initializeWorkflow.workflow.name }
    );
  }, [createWorkflow]);
  const handleCreateGuarded = useAccessGuard({
    callback: handleCreate,
    minRole: Apollo.OrgRole.Basic,
  });

  return (
    <PrimaryPlusIconButton
      disabled={loading}
      tooltip="New Template"
      onClick={handleCreateGuarded}
    />
  );
}
